module.exports = __webpack_public_path__ + "static/media/Smoke-Element.c9d1f6a4.png";